<template>
    <div class="treatment-analysis">
        <div class="chart-row">
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">知识图谱</p>
                <disease-chart :option="graphOption" height="420px" />
            </div>
            <div class="pie-panel w-1-2">
                <div class="chart-card">
                    <p class="chart-card-tit">治则治法占比</p>
                    <disease-chart :option="principleOption" height="190px" />
                </div>
                <div class="chart-card">
                    <p class="chart-card-tit">治疗方式占比</p>
                    <disease-chart :option="methodOption" height="190px" />
                </div>
                <div class="chart-card">
                    <p class="chart-card-tit">经络占比</p>
                    <disease-chart :option="meridianOption" height="190px" />
                </div>
                <div class="chart-card">
                    <p class="chart-card-tit">穴位占比</p>
                    <disease-chart :option="acupointOption" height="190px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import treatmentAnalysisData from '../mock/treatmentAnalysis.json'; 

function buildGraphOption(graph) {
    const categories = graph.categories || [];
    const nodes = graph.nodes || [];
    const links = graph.links || [];
    return {
        tooltip: { trigger: 'item' },
        legend: {
            data: categories.map((item) => item.name),
            bottom: 0,
            textStyle: { color: '#5A6779', fontSize: 11 },
        },
        series: [
            {
                type: 'graph',
                layout: 'force',
                roam: true,
                draggable: true,
                legendHoverLink: false,
                categories,
                data: nodes,
                links,
                label: {
                    show: true,
                    color: '#333',
                    fontSize: 11,
                },
                lineStyle: {
                    color: 'source',
                    curveness: 0.15,
                    opacity: 0.6,
                },
                force: {
                    repulsion: 260,
                    edgeLength: [40, 110],
                    gravity: 0.08,
                },
                emphasis: {
                    focus: 'adjacency',
                    lineStyle: { width: 3 },
                },
            },
        ],
    };
}

function buildPieOption(list, highlightName) {
    const data = list.map((item) => {
        if (highlightName && item.name === highlightName) {
            return {
                ...item,
                itemStyle: { shadowBlur: 6, shadowColor: 'rgba(22, 93, 255, 0.35)' },
            };
        }
        return item;
    });
    return {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        }, 
        series: [
            {
                type: 'pie', 
                center: ['50%', '50%'],
                data,
                label: {
                    formatter: '{b}\n{d}%',
                    fontSize: 12,
                    color: '#333',
                },
                labelLine: {
                    length: 8,
                    length2: 6,
                }, 
                emphasis: {
                    itemStyle: {
                        shadowBlur: 8,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0,0,0,0.15)',
                    },
                },
            },
        ],
    };
}

export default {
    name: 'TreatmentAnalysis',
    components: {
        DiseaseChart,
    },
    data() {
        return {
            chartData: treatmentAnalysisData,
        };
    },
    computed: {
        graphOption() {
            return buildGraphOption(this.chartData.graph || { categories: [], nodes: [], links: [] });
        },
        principleOption() {
            return buildPieOption(this.chartData.principlePie || []);
        },
        methodOption() {
            return buildPieOption(this.chartData.methodPie || [], '中西医结合疗法');
        },
        meridianOption() {
            return buildPieOption(this.chartData.meridianPie || []);
        },
        acupointOption() {
            return buildPieOption(this.chartData.acupointPie || []);
        },
    },
};
</script>

<style lang="less" scoped>
.treatment-analysis {
    .chart-row {
        display: flex;
        gap: 16px;
        align-items: stretch;
    }

    .w-1-2 {
        flex: 1 1 0;
        min-width: 0;
    }

    .chart-card {
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;
    }

    .pie-panel {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 16px;
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
